import React from 'react';
import { Trophy, XCircle, Target, ShieldAlert, ListChecks } from 'lucide-react';

const pct = (v) => `${Math.round((Number(v) > 1 ? Number(v) / 100 : Number(v) || 0) * 100)}%`;
const List = ({ items, color = 'text-slate-300' }) => <ul className={`space-y-1 text-sm ${color}`}>{(items || []).map((t, i) => <li key={i}>• {t}</li>)}</ul>;

export const CrossAnalysisResult = ({ r }) => {
  const e = r.estrategia_optima || {};
  return (
    <div data-testid="cross-analysis-result" className="space-y-4 mt-6">
      <div className="rounded-2xl border border-amber-500/40 bg-gradient-to-br from-amber-500/10 to-slate-900 p-5">
        <div className="flex flex-col md:flex-row justify-between gap-3">
          <div>
            <p className="text-xs uppercase tracking-wider text-amber-400 flex items-center gap-2"><Target className="w-4 h-4" />Estrategia óptima · Cerebro IA</p>
            <p className="text-white mt-1">{e.resumen}</p>
          </div>
          <div className="md:text-right shrink-0">
            <p data-testid="cross-probability" className="text-4xl font-bold text-amber-400">{pct(e.probabilidad_honesta)}</p>
            <p className="text-xs text-slate-400">probabilidad honesta</p>
            <p className="text-xs text-slate-500">{r.casos_analizados?.total} casos · {r.casos_analizados?.ganados} ganados · {r.casos_analizados?.perdidos} perdidos</p>
          </div>
        </div>
        <ol className="mt-4 space-y-2">
          {(e.pasos || []).map((p, i) => (
            <li key={i} className="flex gap-3"><span className="w-6 h-6 shrink-0 rounded-full bg-amber-500 text-slate-950 text-xs font-bold flex items-center justify-center">{i + 1}</span>
              <div><p className="text-white text-sm font-semibold">{p.paso}</p><p className="text-slate-400 text-sm">{p.detalle}</p></div></li>
          ))}
        </ol>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-slate-900/60 border border-slate-700 rounded-xl p-4"><p className="text-sm font-semibold text-green-400 mb-2 flex items-center gap-2"><Trophy className="w-4 h-4" />Patrones ganadores</p><List items={r.patrones_ganadores} /></div>
        <div className="bg-slate-900/60 border border-slate-700 rounded-xl p-4"><p className="text-sm font-semibold text-red-400 mb-2 flex items-center gap-2"><XCircle className="w-4 h-4" />Patrones perdedores</p><List items={r.patrones_perdedores} /></div>
        <div className="bg-slate-900/60 border border-slate-700 rounded-xl p-4"><p className="text-sm font-semibold text-cyan-400 mb-2 flex items-center gap-2"><ListChecks className="w-4 h-4" />Argumentos y pruebas</p><List items={[...(e.argumentos || []), ...(e.pruebas || [])]} /></div>
        <div className="bg-slate-900/60 border border-slate-700 rounded-xl p-4"><p className="text-sm font-semibold text-orange-400 mb-2 flex items-center gap-2"><ShieldAlert className="w-4 h-4" />Por qué no es infalible</p><p className="text-sm text-slate-300">{e.por_que_no_es_infalible}</p><p className="text-xs text-slate-400 mt-2 font-semibold">Plan B</p><List items={e.plan_b} /></div>
      </div>
      <div data-testid="expert-lessons" className="grid md:grid-cols-2 gap-4">
        {(r.lecciones_por_experto || []).map((l, i) => (
          <div key={i} className="bg-slate-900/60 border border-slate-700 rounded-xl p-4">
            <p className="text-white font-semibold text-sm mb-2">Lecciones de {l.experto}</p>
            <p className="text-xs text-green-400">Qué funcionó</p><List items={l.que_funciono} />
            <p className="text-xs text-red-400 mt-2">Qué falló</p><List items={l.que_fallo} />
          </div>
        ))}
      </div>
      {r.advertencia_datos && <p className="text-xs text-slate-400">Solidez de la base: {r.advertencia_datos}</p>}
      {r.fuentes?.length > 0 && (
        <div className="text-xs text-slate-500"><p className="mb-1">Fuentes:</p>{r.fuentes.map((f) => <a key={f} href={f} target="_blank" rel="noreferrer" className="block text-cyan-500 truncate">{f}</a>)}</div>
      )}
    </div>
  );
};
